import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { FormError } from '../../../components/hook-form/hook-form-error';

export enum DateFormat {
  SIMPLE_DATE = 'MM/DD/YYYY',
}

interface DateLimits {
  maxDateEnabled?: boolean;
  maxDateValue?: string;
  minDateEnabled?: boolean;
  minDateValue?: string;
}

interface DateSelectFieldProps {
  label: string;
  name: string;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  format?: DateFormat;
  required?: boolean;
  dateLimits?: DateLimits;
  className?: string;
}

const convertToDate = (value: any) => {
  if (!value || value === 'Invalid Date') return null;
  return dayjs(value).isValid() ? dayjs(value) : null;
};

export const FormDateField = ({
  name,
  label,
  required,
  format = DateFormat.SIMPLE_DATE,
  disabled,
  onChange,
  dateLimits = {},
  className,
}: DateSelectFieldProps) => {
  const { control, getValues } = useFormContext();
  // const {
  //   maxDateEnabled = false,
  //   maxDateValue = dateLimits?.maxDateValue ?? '',
  //   minDateEnabled = false,
  //   minDateValue = dateLimits?.minDateValue ?? '',
  // } = dateLimits;

  // useWatch({
  //   name: [maxDateValue, minDateValue] || [],
  // });
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        control={control}
        name={name}
        rules={{
          required: required ? `${label} is required` : false, // Apply required validation
        }}
        render={({ field: { onChange: fieldOnChange, value } }) => (
          <>
            <DatePicker
              onChange={(date) => {
                const rawDate = convertToDate(date);
                fieldOnChange(rawDate); // Pass raw date to react-hook-form
                onChange && onChange(formatSiTrackDate(rawDate, format)); // Call external onChange with formatted value
              }}
              value={convertToDate(value)}
              sx={{ width: '100%' }}
              slotProps={{
                textField: {
                  size: 'small',
                  label: `${label}`,
                  className: `${className} ${required ? 'itsarequiredField ' : ''} ${value ? 'has-data' : ''} custDateQB`,
                },
              }}
              disabled={disabled}
            />
            <FormError name={name} />
          </>
        )}
      />
    </LocalizationProvider>
  );
};

FormDateField.defaultProps = {
  label: undefined,
  onChange: () => {},
};

export default FormDateField;

// Helper function to format dates
export const formatSiTrackDate = (value: any, format: DateFormat) => {
  if (!value) return '';

  return dayjs(value).format(format);
};
